<template>
  <transition name="fade">
    <div class="full-screen-modal">
      <div is="style" scoped="scoped">
        {{ mobileCSS }}
        {{ activeHoverStyle }}
      </div>
      <div class="menu">
        <h1>リンクチェッカー</h1>
        <div class="close-btn link-checker" @mousedown="onClose" @click="onScriptClose" data-shortcut-esc="linkChecker"><span></span></div>
      </div>
      <multipane class="pane" layout="vertical">
        <div class="html-preview" align="center">
          <div v-html="rawHTML"/>
        </div>
        <multipane-resizer/>
        <div class="link-info" id="link-info">
          <div v-if="isLoading" class="white-wrap">
            <div class="spinner">
              <span>Loading...</span>
            </div>
          </div>
          <div>

            <div class="title">
              <button class="w-b-btn" @click="executeLinkCheck()">Linkチェック</button>
              <h2>リンクチェッカー</h2>
              <span>{{ successLinkCount }}/{{ allLinkCount }}</span>
            </div>
            <pagination
              v-if="linkObjects.length"
              :maxPageIndex="maxPageIndex"
              :currentPageIndex="currentPageIndex"
              @updateCurrentPageIndex="updateCurrentPageIndex"
            />
            <ul>
              <li
                v-for="index in currentPageLinkObjectsIndexArray"
                :key="linkObjects[index].linkCheckerClass"
                :class="{ unlink: failedLink(linkObjects[index].status), success: successLink(linkObjects[index].status), malformed: malformedLink(linkObjects[index].status) }"
                @mouseover="setHoverLink(linkObjects[index])"
                @mouseleave="removeHoverLink()"
              >
                <span class="img" @mousedown.stop>
                  <img
                    class="link-icon"
                    :src="linkObjects[index].iconUrl"
                  />
                </span>
                <dl class="link-list">
                  <dt>{{ linkObjects[index].iconAlt }}</dt>
                  <dd>
                    <span v-show="!linkObjects[index].focus" class="name">
                      {{ linkObjects[index].href }}
                      <a @click="openEditLinkInput(linkObjects[index], index)" @mousedown.stop>
                        <i class="fas fa-pen"></i>
                      </a>
                      <a
                        v-if="!malformedLink(linkObjects[index].status)"
                        :href="linkObjects[index].href"
                        @mousedown.stop target="_blank"
                      >
                        <i class="fas fa-external-link-alt"></i>
                      </a>
                    </span>
                    <span v-show="linkObjects[index].focus">
                      <div class="common-input">
                        <input
                          type="text"
                          :value="linkObjects[index].currentHref"
                          @change="updateLink(linkObjects[index], $event)"
                          @input="linkObjects[index].currentHref = $event.target.value"
                          @keypress.enter="$event.target.blur"
                          @keydown.esc="preventEscDefault"
                          @blur="saveAndCloseEditLinkInput(linkObjects[index])"
                          :ref="'hrefInput' + index"
                        />
                      </div>
                    </span>
                  </dd>
                </dl>
              </li>
            </ul>
            <pagination
              v-if="linkObjects.length"
              :maxPageIndex="maxPageIndex"
              :currentPageIndex="currentPageIndex"
              @updateCurrentPageIndex="updateCurrentPageIndex"
            />
          </div>
        </div>
      </multipane>
    </div>
  </transition>
</template>

<script>
import base from '@/components/Content/Check/ContentCheckBase'
import ShortCutBase from '@/mixins/ShortCutBase'
import Pagination from '@/components/Util/Pagination'
import { Multipane, MultipaneResizer } from 'vue-multipane'
import constants from '@/constants'
import { validateLink, validateUrl, replaceStringFromSpecifcIndex, encodeUrl } from '@/utils/String'

const LINK_STATUS_BEFORE_CHECK = 0
const LINK_STATUS_SUCCESS = 1
const LINK_STATUS_FAILED = 2
const LINK_STATUS_MALFORMED = 10

const PER_PAGE_ITEMS = 10

export default {
  name: 'link-checker',
  mixins: [
    base,
    ShortCutBase
  ],
  components: {
    Multipane,
    MultipaneResizer,
    Pagination,
  },
  data () {
    return {
      mobileCSS: '',
      rawHTML: '',
      isMobile: false,
      contentLinkChecker: '',
      linkObjects: [],
      activeHoverStyle: '',
      currentPageIndex: 1,
      minPageIndex: 1,
      maxPageIndex: 1,
      isLoading: false,
      isClosing: false,
      isDisableUpdateLink: false,
    }
  },
  created () {
    this.initLinkObject()
    this.initPaginator()
  },
  methods: {
    initLinkObject () {
      this.mobileCSS = this.createMobileCSS()
      this.linkObjects = []
      this.contentLinkChecker = JSON.parse(JSON.stringify(this.$store.getters.getSectionAll))
      this.contentLinkChecker.forEach((section, sIndex) => {
        section.parts_containers.forEach((partsContainer, pcIndex) => {
          partsContainer.parts.forEach((part, pIndex) => {
            if (['Text', 'BoxedText', 'Footer', 'Code'].includes(part.type)) {
              // テキスト内の<a>タグを抽出してホバー用のクラスを付与する
              let tmpBody = JSON.parse(JSON.stringify(part.body))

              const hrefRegex = /<a[^>]*(href=["']?[^"']+["']?).*?>/g
              let hrefs = [...tmpBody.matchAll(hrefRegex)]
              // リンクチェッカー用クラスを挿入した際の index のズレ補正用
              let bodyDiffLength = 0
              hrefs.forEach((href, index) => {
                const urlMatch = href[1].match(/href="([^"]*)"/)
                if (urlMatch && urlMatch[1]) {
                  const url = urlMatch[1]
                  const isMalformedUrl = !validateUrl(url)
                  const linkCheckerClass = this.generateRandomClass()
                  this.insertLinkObjects(
                    url,
                    sIndex,
                    pcIndex,
                    pIndex,
                    part.type,
                    index,
                    linkCheckerClass,
                    isMalformedUrl
                  )
                  const classString = ' class="' + linkCheckerClass + '" >'
                  tmpBody = replaceStringFromSpecifcIndex(
                    tmpBody,
                    '>',
                    classString,
                    href.index + bodyDiffLength
                  )
                  bodyDiffLength += (classString.length - 1)
                }
              })

              part.body = tmpBody
            }

            if (['Image', 'Button', 'SnsIcon'].includes(part.type)) {
              // part.attr に linkCheckerClass を付与する。
              if (part.attrs && part.attrs.href) {
                const isMalformedUrl = !validateUrl(part.attrs.href)
                const linkCheckerClass = this.generateRandomClass()
                this.insertLinkObjects(
                  part.attrs.href,
                  sIndex,
                  pcIndex,
                  pIndex,
                  part.type,
                  0,
                  linkCheckerClass,
                  isMalformedUrl
                )
                part.attrs.linkCheckerClass = linkCheckerClass
              }
            }
          })
        })
      })

      this.createRawHTML(this.contentLinkChecker, this.$store.getters.getContentInfoLinkParams, true)
    },
    initPaginator () {
      if (this.linkObjects === []) return
      this.maxPageIndex = Math.ceil(this.linkObjects.length / PER_PAGE_ITEMS)
    },
    onClose () {
      this.isClosing = true
      this.$emit('close')
    },
    onScriptClose (event) {
      // esc のショートカットに対応するため、スクリプトから実行された時のみ閉じる
      if (!event.isTrusted) {
        this.$emit('close')
      }
    },
    openEditLinkInput (link, index) {
      link.focus = true
      if (this.$refs['hrefInput' + index]) {
        this.$nextTick(() =>
          this.$refs['hrefInput' + index][0].focus()
        )
      }
    },
    saveAndCloseEditLinkInput (link) {
      link.focus = false
    },
    generateRandomClass () {
      return 'ms-' + Math.random().toString(32).substring(2)
    },
    insertLinkObjects (url, sIndex, pcIndex, pIndex, partType, insidePartOrder, linkCheckerClass, isMalformedUrl) {
      // リンクチェッカー画面での文字列・アイコン文字
      const linkIcon = this.getLinkIcon(url)
      const status = isMalformedUrl ? LINK_STATUS_MALFORMED : LINK_STATUS_BEFORE_CHECK
      let encodedUrl = null
      if (!isMalformedUrl && url !== encodeUrl(url)) {
        encodedUrl = encodeUrl(url)
      }

      this.linkObjects.push({
        sectionIndex: sIndex,
        partsContainerIndex: pcIndex,
        partIndex: pIndex,
        partType: partType,
        insidePartOrder: insidePartOrder,
        linkCheckerClass: linkCheckerClass,
        href: url,
        encodedHref: encodedUrl,
        currentHref: url,
        status: status,
        focus: false,
        iconAlt: linkIcon.attrs.alt,
        iconUrl: linkIcon.url.color,
      })
    },
    preventEscDefault () {
      this.isDisableUpdateLink = true
    },
    updateLink (link, event) {
      // 閉じるボタンで発火した場合は保存させない
      if (this.isClosing) return
      let newHref = event.target.value

      if (this.isDisableUpdateLink) {
        this.isDisableUpdateLink = false
        return
      }
      // validation
      const errorMessages = validateLink(
        'web', {
          webLink: newHref,
        }
      )
      if (errorMessages.length > 0) {
        // バリデーションエラーで変更前に値が戻る時に、input用URLも値を戻す
        link.currentHref = link.href

        return this.$store.commit('showErrorMessagePopup', errorMessages)
      }

      if (link.href !== newHref) {
        this.$store.commit('updateContentLink', {
          sectionIndex: link.sectionIndex,
          partsContainerIndex: link.partsContainerIndex,
          partIndex: link.partIndex,
          partType: link.partType,
          insidePartOrder: link.insidePartOrder,
          newHref: newHref,
        })
        this.initLinkObject()
      }
    },
    setHoverLink (link) {
      const hoverClass = link.linkCheckerClass
      // コードパーツの場合、赤枠が表示されないためimportantで指定
      this.activeHoverStyle = `a.${hoverClass} {outline: solid 2px red !important;}`
      const el = document.getElementsByClassName(hoverClass)
      if (el && el[0]) {
        this.$nextTick(() =>
          el[0].scrollIntoView()
        )
      }
    },
    removeHoverLink () {
      this.activeHoverStyle = ''
    },
    updateCurrentPageIndex (index) {
      if (index > this.maxPageIndex || index < this.minPageIndex) return
      this.currentPageIndex = index
    },
    async executeLinkCheck () {
      // リンクチェック実行
      // palette スクロール不可へ
      document.getElementById('link-info').style.overflow = 'hidden'
      this.isLoading = true
      const formData = new FormData()
      // エンコードするのでハードコピー
      const linkObjectsSubArray = JSON.parse(JSON.stringify(
        this.linkObjects.slice(this.currentPageLinkObjectsOffset, this.currentPageLinkObjectsOffset + this.currentPageLinkObjectsCount)
      ))
      formData.append('linkList', JSON.stringify(linkObjectsSubArray))
      formData.append('contentId', this.$route.params.id)
      await this.$http({
        type: 'POST',
        url: '/content/link_check',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          if (json.data.linkList) {
            this.linkObjects.splice(this.currentPageLinkObjectsOffset, this.currentPageLinkObjectsCount, ...json.data.linkList)
          }
        }
        this.isLoading = false
        // palette スクロール可へ
        document.getElementById('link-info').style.overflow = 'auto'
      })
    },
  },
  computed: {
    allLinkCount: {
      cache: false,
      get () {
        const links = this.linkObjects
        // malformedLinkを除く
        const allLinks = links.filter((link) => {
          return link.status !== LINK_STATUS_MALFORMED
        })
        return allLinks ? allLinks.length : 0
      }
    },
    successLinkCount: {
      cache: false,
      get () {
        const links = this.linkObjects
        const activeLinks = links.filter((link) => {
          return link.status === LINK_STATUS_SUCCESS
        })
        return activeLinks ? activeLinks.length : 0
      }
    },
    currentPageLinkObjectsOffset: {
      cache: false,
      get () {
        return PER_PAGE_ITEMS * (this.currentPageIndex - 1)
      }
    },
    currentPageLinkObjectsCount: {
      cache: false,
      get () {
        if (this.linkObjects.length - this.currentPageLinkObjectsOffset > PER_PAGE_ITEMS) {
          return PER_PAGE_ITEMS
        } else {
          return this.linkObjects.length - this.currentPageLinkObjectsOffset
        }
      }
    },
    currentPageLinkObjectsIndexArray: {
      cache: false,
      get () {
        // 表示用のindex配列
        return Array.from(
          { length: this.currentPageLinkObjectsCount },
          (nouse, index) => index + this.currentPageLinkObjectsOffset
        )
      }
    },
    successLink: () => {
      return (status) => {
        return status === LINK_STATUS_SUCCESS
      }
    },
    failedLink: () => {
      return (status) => {
        return status === LINK_STATUS_FAILED
      }
    },
    malformedLink: () => {
      return (status) => {
        return status === LINK_STATUS_MALFORMED
      }
    },
    getLinkIcon: () => {
      return (href) => {
        const findOrigin = (href, hrefsArray) => {
          // href の先頭に hrefsArray のどれかが含まれているか
          const escapeHrefsArray = hrefsArray.map(
            href => {
              // 正規表現に入れるため各URLをエスケープする
              const escapeRegex = (string) => {
                return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
              }
              return escapeRegex(href)
            }
          )
          // 正規表現を1回で実行するためjoinする
          const reg = new RegExp('^(' + escapeHrefsArray.join('|') + ')')
          return reg.test(href)
        }

        switch (true) {
          case href.startsWith('mailto:'):
            return constants.emailIcon
          case href.startsWith('tel:'):
            return constants.telIcon
          case findOrigin(href, constants.xIcon.hrefs):
            return constants.xIcon
          case findOrigin(href, constants.facebookIcon.hrefs):
            return constants.facebookIcon
          case findOrigin(href, constants.youtubeIcon.hrefs):
            return constants.youtubeIcon
          case findOrigin(href, constants.instagramIcon.hrefs):
            return constants.instagramIcon
          case findOrigin(href, constants.lineIcon.hrefs):
            return constants.lineIcon
          default:
            return constants.websiteIcon
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 編集ページ
.full-screen-modal {
  // リサイズ可能なペインをラップするクラス
  .menu {
    height: $navbarHeight;
    line-height: $navbarHeight;
    padding-left: 20px;
    color: #fff;
    font-size: 24px;
    background: $primaryMenuColor;
    .close-btn {
      top: 7px;
    }
  }
  .pane {
    height: calc(100vh - #{$defaultTopMargin} - #{$navbarHeight});
    // 左側：プレビュー
    .html-preview {
      width: $previewHTMLWidth;
      overflow-y: scroll;
    }
    // 右側：パレット
    .link-info {
      width: $headerInfoWidth;
      color: $commonFontColor;
      overflow-y: scroll;
      flex-grow: 1;
      background: #f8f8f8;
      border-left: #dbdbdb 1px solid;
      padding: 15px;
      box-sizing: border-box;
      position: relative;
      button {
        position: absolute;
        top:10px;
        left: 10px;
        font-size: 12px;
      }
      .white-wrap {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: #FFF;
        opacity: 0.5;
        transition: all 0.5s ease 0s;
      }
      .title {
        text-align: center;
        margin-bottom: 10px;
        h2 {
          font-size: 18px;
          display: inline-block;
        }
        span {
          font-size: 12px;
          display: inline-block;
          padding: 0 8px;
          margin-left: 8px;
          height: 22px;
          line-height: 22px;
          border-radius: 13px;
          background: #e4e4e4;
        }
      }
      ul {
        margin-bottom: 10px;
        li {
          font-size: 14px;
          border-top: #dbdbdb 1px solid;
          padding: 5px 10px;
          display: flex;
          &:last-of-type {
            border-bottom: #dbdbdb 1px solid;
          }
          &.unlink {
            background: rgba(red, 0.2);
          }
          &.success {
            background: rgba(green, 0.2);
          }
          &.malformed {
            background: rgba(gray, 0.2);
          }
          .name {
            word-break: break-all;
            a {
              margin: 2px;
              display: inline;
              cursor: pointer;
              &:nth-of-type(2) {
                margin-left: 13px;
              }
            }
          }
          .pen {
            display: inline;
            width: 14px;
            min-width: 14px;
          }
          .img {
            width: 48px;
            min-width: 48px;
            height: 48px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 10px;
          }
          .link-icon {
            width: 48px;
          }
          .link-list {
            width: 100%;
          }
        }
      }
    }
  }
}
.common-input {
  max-width: 300px;
  width: 100%;
}

@media screen and ( max-width: 1400px ) {
  .full-screen-modal {
    .pane {
      .link-info {
        button {
          position: relative;
          top: 0px;
          left: 0px;
        }
        .title {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          h2 {
            margin-left: 5px;
            flex-shrink: 0;
          }
        }
      }
    }
  }
}
</style>
